import { sprintf } from 'sprintf-js';
import { debugLogger } from '../debug/DebugLogger';

export const formatString = (
  formattingString: string,
  value: number | string
): string | number => {
  try {
    return sprintf(formattingString, value);
  } catch (error) {
    /** @debugFeature formatting Logs a sprintf formatting string that failed, with the value and the error. */
    debugLogger.log('formatting', 'sprintf failed', () => ({
      formattingString,
      value,
      error,
    }));
    return value;
  }
};
